import { render } from "./g-login-login__mfa.vue?vue&type=template&id=4373fb99&ts=true"
import script from "./g-login-login__mfa.vue?vue&type=script&lang=tsx"
export * from "./g-login-login__mfa.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__